import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'contactUsEnquiry',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'contactUsEnquiryApi',
  baseQuery,
  tagTypes: ['Contact-us-enquiry'],
  endpoints: builder => ({
    getList: builder.query({
      query: (params: any) => ({
        url: endpoints.CONTACT_US_ENQUIRY,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { actions: contactUsEnquiryAction } = slice;

export const useContactUsEnquirySlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: contactUsEnquiryAction,
    useGetListQuery: api.useLazyGetListQuery,
  };
};
